"use client";

import { Languages } from "lucide-react";

import { DEFAULT_LOCALE, SECONDARY_LOCALE, isSecondaryLocaleEnabled } from "@/i18n/config";
import { useLocaleSwitch } from "@/hooks/useLocale";

const BASE_STYLES =
  "inline-flex h-10 items-center justify-center gap-1.5 rounded-lg border px-2.5 text-[12px] font-black transition-colors";
const DEFAULT_STYLES = "border-border bg-muted text-foreground hover:border-primary-main/40";

interface Props {
  className?: string;
}

export default function LocaleSwitcher({ className }: Props) {
  const { locale, switchAppLocale } = useLocaleSwitch();

  if (!isSecondaryLocaleEnabled()) return null;

  const target = locale === SECONDARY_LOCALE ? DEFAULT_LOCALE : SECONDARY_LOCALE;
  const label = target === SECONDARY_LOCALE ? "EN" : "فارسی";

  return (
    <button
      type="button"
      onClick={() => switchAppLocale(target)}
      aria-label={label}
      title={label}
      className={`${BASE_STYLES} ${className ?? DEFAULT_STYLES}`}
    >
      <Languages size={14} />
      <span>{label}</span>
    </button>
  );
}
